export const blockIconsSocialConstruction = (
	<span className='material-symbols-outlined'>construction</span>
);
